import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { removeUserFromBlacklistStart } from '../../../redux/blacklist/blacklist.actions';
import { useModal } from '../../../hooks';
import ConfirmationModal from '../../ConfirmationModal';
import { SadUserIcon } from '../../../assets/icons';
import useTranslation from 'hooks/useTranslation';

const BlackListItem = ({ id, ip }) => {
  const dispatch = useDispatch();
  const [visible, toggle] = useModal();
  const { getTranslation } = useTranslation("BLACKLIST");
  const { t } = getTranslation();

  const handleRemoveUserFromBlacklist = (event) => {
    if (event) event.preventDefault();

    dispatch(removeUserFromBlacklistStart({ ip }));
    toggle();
  };

  const openConfirmationModal = (event) => {
    if (event) event.preventDefault();
    toggle();
  };

  return (
    <div className='blacklist__list'>
      <div className='blacklist__list__inner flex flex-ai-c flex-jc-sb'>
        <div className='blacklist__list__inner__title flex flex-ai-c'>
          <div className='blacklist__list__inner__title__img grid grid-pi-c'>
            <img src={SadUserIcon} alt='' />
          </div>
          <div className='blacklist__list__inner__title__ip'>{ip}</div>
        </div>
        <a href='#/' className='btn btn-ghost' onClick={openConfirmationModal}>
          {t("DELETE_FROM_BLACK_LIST")}
        </a>
        <ConfirmationModal
          message={t("DELETE_FROM_BLACK_LIST_CONFIRM")}
          onConfirm={handleRemoveUserFromBlacklist}
          visible={visible}
          toggle={toggle}
          cancelText={t("CONFIRM_MODAL_CANCEL")}
          confirmText={t("CONFIRM_MODAL_CONFIRM")}
        />
      </div>
    </div>
  );
};

BlackListItem.propTypes = {
  id: PropTypes.string.isRequired,
  ip: PropTypes.string.isRequired,
};

export default BlackListItem;
